import { addDoc, collection, getDocs } from 'firebase/firestore';
import { useMemo } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { db } from '../firebase';
import { Group } from '../models/group';

export const useGroupList = () => {
  const groupCollection = useMemo(() => collection(db, '/groups'), []);
  const queryClient = useQueryClient();

  const { data: groups = [] } = useQuery('/groups', async () => {
    const snapshot = await getDocs(groupCollection);
    const result: Group[] = [];
    snapshot.forEach((d) => {
      if (d.exists()) {
        result.push({ id: d.id, ...d.data() } as Group);
      }
    });
    return result;
  });

  const { mutate: addGroup } = useMutation(
    async (group: Omit<Group, 'id'>) => {
      addDoc(groupCollection, group);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('/groups');
      },
    }
  );

  return {
    groups,
    addGroup,
  };
};
